<div class="ws-stretch-height">
    <div class="ws-flex-container-vertical ws-stretch-height">
        <div class="card panel-flat-color secondary-panel ws-stretch-height">
            <div class="panel-flat-header"
                 [style.cursor]="isCompany ? 'pointer' : ''"
                 (click)="expandOrCollapse()">
                @if (isCompany) {
                    <panel-chevron [showBody]="showBody"></panel-chevron>
                }
                <h3>{{ isCompany ? 'Company' : currentEntity.name }} Characteristics</h3>
                <div class="float-end header-button-container">
                    <!-- margin: -1px is a hack to make sure the buttons stay on the header if the window is narrow -->
                    @if (hasInstancePrivateView && (!isCompany || showBody)) {
                        <button type="button" class="ace-btn btn-text has-icon"
                                (click)="launchChangeHistoryModal($event)">
                            <i class="fa fa-history"></i>
                        </button>
                    }
                    <!-- button to show form -->
                    @if (hasWritePermission && !isEditMode && !editLock && (!isCompany || showBody)) {
                        <button type="button" class="ace-btn btn-text has-icon btn-primary"
                                (click)="goToEditMode($event)"
                        >
                            <i class="fa fa-pencil"></i>
                        </button>
                    }
                    @if (isEditMode) {
                        <span>
              <button type="button" class="ace-btn btn-text has-icon btn-primary btn-success"
                      (click)="save($event)"
                      [disabled]="loading">
                <i class="fa fa-save"></i>
              </button>
              <button type="button" class="ace-btn btn-text has-icon" [disabled]="loading"
                      (click)="cancel($event)">
                <i class="fa fa-close"></i>
              </button>
            </span>
                    }
                    @if (allowMaximize && !isCompany) {
                        <span>
              @if (!isMaximized) {
                  <button type="button" class="ace-btn btn-text has-icon btn-secondary"
                          style="margin-right: -1px;"
                          (click)="maximize()">
                  <i class="fa fa-arrows-alt"></i>
                </button>
              }
                            @if (isMaximized) {
                                <button type="button" class="ace-btn btn-text has-icon btn-secondary"
                                        style="margin-right: -1px;"
                                        (click)="unmaximize()">
                  <i class="fa fa-compress"></i>
                </button>
                            }
            </span>
                    }
                </div>
                <div class="clearfix"></div>
            </div>
            @if (showBody) {
                <div class="panel-flat-body" [class.large]="isParcel" style="max-width: 700px; overflow: auto;"
                     [ngClass]="{'site-parcel-list-panel-height': currentEntity.entityTypeId == EntityTypes.Site,
                'panel-flat-body-alt': currentEntity.entityTypeId == EntityTypes.Collector }"
                >
                    @if (loading) {
                        <div class="text-center" style="margin-top: 50px;">
                            <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                        </div>
                    }
                    @if (!loading) {
                        <div>
                            @if (!isEditMode) {
                                <div style="display: flex; justify-content: end; margin-bottom: 15px;">
                                    <ws-switch onLabel="Categories" offLabel="Alphabetical" [(ngModel)]="sortByCategory"></ws-switch>
                                </div>
                            }
                            @if (isEditMode) {
                                <property-characteristics-picker
                                    [entityId]="currentEntity.entityId"
                                    [entityName]="currentEntity.name"
                                    (descriptorsSelected)="descriptorsSelected($event)"
                                    [descriptorsToExclude]="descriptorsAlpha">
                                </property-characteristics-picker>
                            }
                            @if (!sortByCategory) {
                                <entity-property-characteristics-list [descriptors]="descriptorsAlpha" [isEditMode]="isEditMode" [saveAttempted]="saveAttempted"></entity-property-characteristics-list>
                            }
                            @if (sortByCategory) {
                                <accordion [closeOthers]="false" [isAnimated]="true" class="entity-prop-char-panel">
                                    @for (category of descriptorCategories; track category) {
                                        <accordion-group
                                            style="margin-bottom: 15px;"
                                            [(isOpen)]="category.isOpen">
                                            <button class="btn-block clearfix" style="border: none;" accordion-heading>
                                                <div class="float-start float-left">
                                                    <panel-chevron [showBody]="category.isOpen"></panel-chevron>
                                                    {{ category.name }}
                                                </div>
                                            </button>
                                            <entity-property-characteristics-list [descriptors]="category.descriptors" [isEditMode]="isEditMode" [saveAttempted]="saveAttempted"></entity-property-characteristics-list>
                                        </accordion-group>
                                    }
                                </accordion>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
